/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import {connect} from 'react-redux'
import Config from '../../config'
import '../../styles/search/SearchPage.css'
import {renderMoney, TimeStream} from '../../utils'
import { toLecture } from '../../utils/connectApp'
import ChannelPersonCount from '../../images/channel-person-cuont.png'


class CurrencyItem extends React.Component {
    static defaultProps = {
        border: 'top',
        marginBottom: false
    };

    constructor (){
        super();
        this.handleClickLog = this.handleClickLog.bind(this)
    }

    renderBorder(type) {
        switch (type){
            case 'top':
                return 'currency-item-border-top';
            case 'bottom':
                return 'currency-item-border-bottom';
            case 'none':
                return 'currency-item-border-none';
            default:
                return 'currency-item-border-top';
        }
    }

    renderLectureMode() {
        const lecture = this.props.content;
        if (lecture.lecture_type === 'password_lecture') {
            return (
                <span className="liveroom-lecture-tag">
                    <i className="icon iconfont icon-suo tag-mode-fontsize"></i>
                </span>
            )
        }
    }

    renderLectureTag() {
        const lecture = this.props.content;
        if (lecture.lecture_mode === 'default'){
            switch (lecture.image_mode) {
                case 'video':
                    return (
                        <span className="liveroom-lecture-mode">
                        <i className="icon iconfont icon-shipin1 tag-mode-fontsize"></i>
                    </span>
                    );
                case 'audio':
                    return (
                        <span className="liveroom-lecture-mode">
                        <i className="icon iconfont icon-erji tag-mode-fontsize"></i>
                    </span>
                    );
                default:
                    return true
            }
        }else {
            switch (lecture.lecture_mode) {
                case 'video':
                    return (
                        <span className="liveroom-lecture-mode">
                        <i className="icon iconfont icon-shipin1 tag-mode-fontsize"></i>
                    </span>
                    );
                case 'audio':
                    return (
                        <span className="liveroom-lecture-mode">
                        <i className="icon iconfont icon-erji tag-mode-fontsize"></i>
                    </span>
                    );
                default:
                    return true
            }
        }
    }

    renderLectureTime() {
        const lecture = this.props.content;
        if (lecture.status === 'closed'){
            if (lecture.audio_length <= 5){
                return TimeStream(lecture.start_timestamp, 'YMD')
            }else {
                return '时长' + lecture.audio_length + '分钟'
            }
        }else {
            if (lecture.start_timestamp * 1000 < Date.parse(new Date())){
                return '正在进行'
            }else {
                let time = 0;
                if ((lecture.start_timestamp * 1000) - Date.parse(new Date()) >= 86400000){
                    time = TimeStream(lecture.start_timestamp,'-D') + '天后'
                }else {
                    time = TimeStream(lecture.start_timestamp,'-H') + '小时后'
                }
                return time
            }
        }
    }

    renderLink() {
        const {content, type} = this.props;
        if (type){
            if (type === 'channel'){
                if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())){
                    return `lizhiweike://channel?channel_id=${content.id}`
                }else {
                    return `/channel/${content.id}`
                }
            }else if (type === 'lecture'){
                if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())){
                    return toLecture({ id: content.id, lectureMode: content.lecture_mode, isReturn: true })
                }else {
                    return `/lecture/${content.id}?st=lzwk_inside&inviter_id=24382094`
                }
            }
        }
    }

    handleClickLog() {
        const {search, account, content, type} = this.props;
        this.props.dispatch({
            type: "STATS_LOG",
            payload: {
                action: 'seasult_enter',
                ts: new Date().getTime(),
                account_id: account && account.id,
                keyword: search.search_text,
                type: type,
                target_id: content.id
            }
        });
    }

    render() {
        const {content, type, marginBottom} = this.props;

        return (
            <a href={this.renderLink()}>
                <div className={"currency-item " + this.renderBorder(this.props.border) + (marginBottom ? ' currency-item-margin-bottom' : '')}>
                    <div className="currency-item-left">
                        <div className="currency-item-img background-image" style={{backgroundImage: `url(${content.cover_url})`}}>
                            {type && type === 'lecture' &&
                            this.renderLectureMode()
                            }
                            {type && type === 'lecture' &&
                            this.renderLectureTag()
                            }
                        </div>
                    </div>
                    <div className="currency-item-right">
                        <p className="currency-item-right-title">
                            {content.name}
                        </p>
                        <div className="currency-item-right-mid">

                        </div>
                        <div className="currency-item-right-bottom">
                            <div className="currency-item-right-bottom_left">
                                <div className="currency-item-right-bottom_left-count-time">
                                    {type && type === 'channel' &&
                                    <p>已更新{content.lecture_count}期</p>
                                    }
                                    {type && type === 'lecture' &&
                                    <p>{this.renderLectureTime()}</p>
                                    }
                                </div>
                                <div className="currency-item-right-bottom_left-count">
                                    <img src={ChannelPersonCount} alt=""/>
                                    <p>{content.popular}</p>
                                </div>
                            </div>
                            {type && type === 'lecture' && content.money &&
                            <div className="currency-item-right-bottom_right">
                                <p>￥{renderMoney(content.money)}</p>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </a>
        )
    }
}

export default connect(state => ({
    search: state.search,
    account: state.account
}))(CurrencyItem)


// WEBPACK FOOTER //
// ./src/components/search/CurrencyItem.js